/*global angular */
'use strict';

angular.module('MrDWebApp').controller('PaymentConfirmCtrl', function ($scope, $cookies, storage, order, orderFactory, status, $state, $stateParams, $rootScope) {

  var _pcc = this;

  _pcc.orderId = $stateParams.orderID;
  _pcc.order = order;
  _pcc.status = status;
  _pcc.isWorking = false;

  $scope._rc.bodyClass = 'html-confirm';
  
  if(!$scope._rc.cart.id){
    $scope._rc.cart = storage.get('mrd-web-cart'); //why????
  }

  order
  .$promise
  .then(function (order) {
    if (order.status === 'awaiting_feedback' && order.payment.status === 'paid') {
      $state.go('payment_return', {
        orderID: $scope._rc.cart.id,
        userID: $scope._rc.access.user.id,
        statusID: 'cash'
      });
    } else switch (order.status) {
      case 'delivered':
      case 'restaurant_accepted':
      case 'delivery_instruction_received':
      case 'en_route_to_collection':
      case 'at_restaurant':
      case 'en_route_to_delivery':
      case 'nearby':
      case 'doorbell':
      case 'delivered':
      case 'system_auto_rejected':
      case 'restaurant_auto_rejected':
      case 'restaurant_rejected':
      case 'cancelled':
      case 'failed_delivery_injection':
      case 'failed_restaurant_injection':
      case 'failed_delivery':
      case 'user_confirmed_payment':
      case 'awaiting_feedback':
        if($scope._rc.variables.address.latitude && 
          $scope._rc.variables.address.longitude && 
          $scope._rc.variables.address.street_name){
          $state.go('location', {
            lat: $scope._rc.variables.address.latitude,
            lng: $scope._rc.variables.address.longitude,
            street_name: $scope._rc.variables.address.street_name
          });
        } else {
          if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
        }
        break;
      
      default:
        $scope.showConfirmation = true;
      break;
    }
  });

  _pcc.confirmCash = function () {
    $scope._rc.track('checkout','view_cash_confirmation_screen');

    if ($scope._rc.cart.status === 'user_confirmed_details') {
      $scope._rc.cart.status = 'user_confirmed_payment';
    }
    var payload = angular.copy($scope._rc.cart);
    delete payload.restaurant;

    _pcc.isWorking = true;

    orderFactory.update({
      'userID': $scope._rc.access.user.id,
      'orderID': $scope._rc.cart.id
    }, payload, function success(response) {

      _pcc.isWorking = false;

      angular.extend($scope._rc.cart, response);

      $rootScope.$broadcast('cart:modified');

      storage.set('mrd-web-cart', $scope._rc.cart);

      $state.go('payment_return', {
        orderID: $scope._rc.cart.id,
        userID: $scope._rc.access.user.id,
        statusID: 'cash'
      });

    }, function err() {
      _pcc.isWorking = false;
      $rootScope.$broadcast('global_message:show',  {
        'name': 'confirm_cash_order',
        'for_state' : 'payment_confirm',
        'error' : {
          'friendly_message': 'The restaurant seems to be offline right now...'
        },
        'confirm' : {
          'label': 'Try Again...',
          'action' : 'close',
          'value' : true,
          'value_object': null
        },
        'deny' : {
          'label' : 'Back to Restaurants',
          'action' : 'redirect',
          'value' : 'location',
          'value_object' : null
        }
      });
    });

  };

});
